<template>
    <el-input class="x-number"  :clearable="true" type="number" :model-value="displayValue"
        :disabled="readonly || config.readonly" :placeholder="config.placeholder" :maxlength="config.maxlength || 100"
        :suffix-icon="config.icon" :oninput="input = inputNum(input)"
        @update:modelValue="(value, oldvalue) => $emit('update:modelValue', value, oldvalue)">
        <template v-if='config.suffix' #append>{{ config.suffix }}</template>
    </el-input>
</template>
<script setup>
import { isNumber } from 'element-plus/lib/utils/types';
import { isNil } from 'lodash';
import { computed, defineProps, ref } from 'vue';

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})
const input = ref(undefined)
const inputNum = (value) => {
    if (value == undefined) return;
    return value
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^\./g, "");
}
const displayValue = computed(() => {
    let currentValue= props.modelValue
    if (isNil(currentValue)) return ''
    console.log(isNumber(currentValue))
    if (isNumber(currentValue)) {
      if (Number.isNaN(currentValue)) return ''
    }
    return currentValue
  })
defineEmits({
    'update:modelValue': null,
})
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
